export default __webpack_public_path__ + "static/media/SENAIT_FR_EPILOG3.b30b03a7.mp3";